// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading-text-box {
  padding: 0.625rem 0 0 2rem;
  margin-bottom: 4rem;
  position: relative;
}
.heading-text-box .heading-img {
  width: 100%;
  max-width: 6.125rem;
  height: auto;
  z-index: 0;
  position: absolute;
  top: 0;
  left: 0;
}
.heading-text-box .heading-text {
  color: var(--black-1000);
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 1.4;
  z-index: 1;
  position: relative;
}
.heading-text-box .heading-text span {
  display: block;
}
@media screen and (max-width: 991.98px) {
  .heading-text-box {
    padding: 0.375rem 0 0 1.25rem;
    margin-bottom: 2.5rem;
  }
  .heading-text-box .heading-img {
    max-width: 4rem;
  }
  .heading-text-box .heading-text {
    font-size: 1.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .heading-text-box {
    padding: 0.25rem 0 0 1rem;
    margin-bottom: 2rem;
  }
  .heading-text-box .heading-img {
    max-width: 3.25rem;
  }
  .heading-text-box .heading-text {
    font-size: 1.25rem;
  }
}
@media screen and (max-width: 474.98px) {
  .heading-text-box {
    padding: 0.25rem 0 0 1rem;
    margin-bottom: 2rem;
  }
  .heading-text-box .heading-text span {
    display: inline;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common_UI_Kit/SectionHeading/SectionHeadingStyle.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;AACJ;AAEE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AAIE;EA5BF;IA6BI,6BAAA;IACA,qBAAA;EADF;EAGE;IACE,eAAA;EADJ;EAIE;IACE,iBAAA;EAFJ;AACF;AAKE;EAzCF;IA0CI,yBAAA;IACA,mBAAA;EAFF;EAIE;IACE,kBAAA;EAFJ;EAKE;IACE,kBAAA;EAHJ;AACF;AAME;EAtDF;IAuDI,yBAAA;IACA,mBAAA;EAHF;EAMI;IACE,eAAA;EAJN;AACF","sourcesContent":[".heading-text-box {\n  padding: 0.625rem 0 0 2rem;\n  margin-bottom: 4rem;\n  position: relative;\n\n  .heading-img {\n    width: 100%;\n    max-width: 6.125rem;\n    height: auto;\n    z-index: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  .heading-text {\n    color: var(--black-1000);\n    font-size: 2.25rem;\n    font-weight: 700;\n    line-height: 1.4;\n    z-index: 1;\n    position: relative;\n\n    span {\n      display: block;\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 0.375rem 0 0 1.25rem;\n    margin-bottom: 2.5rem;\n\n    .heading-img {\n      max-width: 4rem;\n    }\n\n    .heading-text {\n      font-size: 1.5rem;\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 0.25rem 0 0 1rem;\n    margin-bottom: 2rem;\n\n    .heading-img {\n      max-width: 3.25rem;\n    }\n\n    .heading-text {\n      font-size: 1.25rem;\n    }\n  }\n\n  @media screen and (max-width: 474.98px) {\n    padding: 0.25rem 0 0 1rem;\n    margin-bottom: 2rem;\n\n    .heading-text {\n      span {\n        display: inline;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
